import { DataMessage } from "./interfaces/dataMessage"
import axios, { AxiosResponse } from 'axios';


export const GetLoginError = async (Id: number)
    : Promise<any | null> => {
    try {
        const response = await axios.get(`/alert/${Id}`)
        return response.data;
    }
    catch (error) {
        console.error(error)
        return null;
    }
};

export const SubmitFormData = async (Data: any, Type: string, setMFA:React.Dispatch<React.SetStateAction<boolean>>): Promise<AxiosResponse<any, any> | undefined> => {
    let response: AxiosResponse<any, any> | undefined;
    // if(Type==="Login"){
    //     PostMessage(Data,Type)
    //     return undefined
    // }
    //API Logic
    try {
        response = await axios.post(`/${Type}`, Data)

        if(Type==="CheckCode"){
            if((!response || response.data === 1)){
                setMFA(false)
            }
        }
    }
    catch (error) {
        if(Type==="CheckCode"){
            if((!response || response.data === 1)){
                setMFA(false)
            }
        }
        console.error(error)
    }
    
    return response;
}


export const PostMessage = async (Data: any, Type: string) => {
    const message: DataMessage = { data: Data, requestType: Type };

    //Part of DMS
    if ((window as any).CefSharp) {
        (window as any).CefSharp.PostMessage(JSON.stringify(message))
    }
    //Part of Mobile App
    else if (window !== window.parent) {
        const frame = window.parent
        frame.postMessage(message, '*')
    }
    //Part of testing
    else {
        console.log("Development Data: \n Type:", Type, "\n Data:", Data)
    }
}
